import React, { useState, useEffect } from 'react';
import { Table, Spin } from 'antd';
import axios from 'axios';

const TableWithPagination = ({ url, columns }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const fetchData = async (page = 1, pageSize = 10) => {
        setLoading(true);
        try {
            const response = await axios.get(url, {
                params: {
                    page,
                    pageSize,
                },
            });
            const { data: fetchedData, total } = response.data;
            setData(fetchedData);
            setPagination((prev) => ({
                ...prev,
                current: page,
                pageSize,
                total,
            }));
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(pagination.current, pagination.pageSize);
    }, []);

    const handleTableChange = (pagination) => {
        fetchData(pagination.current, pagination.pageSize);
    };

    return (
        <Spin spinning={loading}>
            <Table
                columns={columns}
                dataSource={data}
                rowKey={(record) => record.id}
                pagination={pagination}
                onChange={handleTableChange}
            />
        </Spin>
    );
};

export default TableWithPagination;
